import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var _types$SET_CART_SUCCE;

import * as types from './types';
export default (_types$SET_CART_SUCCE = {}, _defineProperty(_types$SET_CART_SUCCE, types.SET_CART_SUCCESS, function (state, payload) {
  var currentState = state;
  currentState.customer.cartSuccess = payload;
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CUSTOMER, function (state, payload) {
  var currentState = state;
  currentState.customer = _objectSpread({}, currentState.customer, payload);
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CART, function (state, payload) {
  var currentState = state;
  currentState.customer.cart = payload.cart;
}), _defineProperty(_types$SET_CART_SUCCE, types.PUSH_CART, function (state, payload) {
  var currentState = state;
  currentState.customer.cart += Number(payload.quantity);
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CURRENT_ITEM_QTY, function (state, payload) {
  var currentState = state;
  currentState.customer.cartItems[payload.reference] = Number(payload.quantity);
}), _types$SET_CART_SUCCE);